
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import TheSelect from '@/common/components/UI/TheSelect/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'

// classes
import { DataState } from '@/core/classes/DataState.class'

// types
import { UserT } from '@/core/types/users.types'

//realisations
import { users } from '@/core/realisations/users.realisation'

export default defineComponent({
    components: {
        TheButton,
        TheSelect,
        TheInput,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['reset', 'search'],
    setup(props, { emit }) {
        const state = reactive({
            number: null as string | null,
            createdAtFrom: null as number | null,
            createdAtTo: null as number | null,
            createdBy: null as number | null,
        })

        const data_state = reactive({
            managers: new DataState<UserT>({}),
        })

        const reset = () => {
            if (props.loading) return

            state.number = null
            state.createdAtFrom = null
            state.createdAtTo = null
            state.createdBy = null

            emit('reset')
        }

        const search = () => {
            if (props.loading) return

            emit('search', {
                ...state,
            })
        }

        // MANAGERS

        const loadManagers = async (page: number, search?: string) => {
            data_state.managers.pagination.current_page = page

            try {
                data_state.managers.is_loading = true

                const response = await users.getList({ page, name: search, roleId: 15 })

                data_state.managers.list = response.data
                data_state.managers.pagination.total_pages = response.meta.last_page

                data_state.managers.is_failed = false
                data_state.managers.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.managers.failure.catchError(error)

                if (!data_state.managers.failure.error_state.is_cancel) {
                    data_state.managers.is_failed = true
                }
            } finally {
                if (!data_state.managers.failure.error_state.is_cancel) {
                    data_state.managers.is_loading = false
                }
            }
        }

        const loadMoreManagers = async (page: number) => {
            if (page > data_state.managers.pagination.total_pages) return
            data_state.managers.pagination.current_page = page

            try {
                data_state.managers.is_loading = true

                const response = await users.getList({ page, roleId: 15 })
                data_state.managers.list = data_state.managers.list.concat(response.data)

                data_state.managers.pagination.total_pages = response.meta.last_page

                data_state.managers.is_failed = false
                data_state.managers.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.managers.failure.catchError(error)

                if (!data_state.managers.failure.error_state.is_cancel) {
                    data_state.managers.is_failed = true
                }
            } finally {
                if (!data_state.managers.failure.error_state.is_cancel) {
                    data_state.managers.is_loading = false
                }
            }
        }

        const searchManagers = async (search_query: string) => {
            // data_state.managers.pagination.current_page
            await loadManagers(1, search_query)
        }

        const unshiftFindedManager = async (manager: UserT) => {
            await loadManagers(data_state.managers.pagination.current_page)
            data_state.managers.list.unshift(manager)
        }

        //

        onBeforeMount(() => {
            loadManagers(1)
        })

        return {
            state,
            data_state,
            //
            reset,
            search,
            //
            loadManagers,
            loadMoreManagers,
            searchManagers,
            unshiftFindedManager,
        }
    },
})
